import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TransitMapPage } from './transit-map.page';

const routes: Routes = [
  {
    path: '',
    component: TransitMapPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TransitMapPageRoutingModule {}
